export default {"src":"https://www.levande.com.au/_next/static/media/map-marker.502d5b3d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};